import { createContext, useContext, useState, type Dispatch, type ReactNode, type SetStateAction } from 'react';
import { Medicine, buildInitialMedicines } from '../types/medicine';

type MedicinesCatalogContextValue = {
  medicines: Medicine[];
  setMedicines: Dispatch<SetStateAction<Medicine[]>>;
};

const MedicinesCatalogContext = createContext<MedicinesCatalogContextValue | null>(null);

export function MedicinesCatalogProvider({ children }: { children: ReactNode }) {
  const [medicines, setMedicines] = useState<Medicine[]>(buildInitialMedicines);

  return (
    <MedicinesCatalogContext.Provider value={{ medicines, setMedicines }}>{children}</MedicinesCatalogContext.Provider>
  );
}

export function useMedicinesCatalog(): MedicinesCatalogContextValue {
  const ctx = useContext(MedicinesCatalogContext);
  if (!ctx) {
    throw new Error('useMedicinesCatalog debe usarse dentro de MedicinesCatalogProvider');
  }
  return ctx;
}
